// The canvas — Phase 05b. Renders every module in the store into #workspace, in store
// order (= DOM order = stacking order, as main.js appended them).
//
// A portal, not a root on #workspace: the workspace also holds nodes that aren't
// modules (the welcome screen, the snap indicator, drag ghosts…), which a portal leaves
// alone — React only inserts and removes its own children.
//
// Its gestures are hooks (Phase 05 decision 1): box-select and the selection keys (05d).

import { createPortal } from "react-dom";
import { useProtoStore } from "../store/store.js";
import { PlacedModule } from "./PlacedModule.js";
import { useBoxSelect } from "./useBoxSelect.js";
import { useSelectionKeys } from "./useSelectionKeys.js";

export function Canvas({ workspace }: { workspace: HTMLElement }) {
  const modules = useProtoStore((s) => s.modules);
  useBoxSelect(workspace);
  useSelectionKeys();
  return createPortal(
    modules.map((m) => <PlacedModule key={m.id} module={m} />),
    workspace,
  );
}
